// client/src/utils/htmlText.js

/**
 * Strip HTML tags from a rich-text field (e.g. property title) for use in
 * contexts that can't render HTML: element attributes (alt, title tooltips)
 * and plain-text templates (email subject lines).
 */
export const stripHtml = (html) => {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "").trim();
};
